import * as Zod from 'zod';

import { translate } from 'utils/i18n';

export const offerEventDateValidator = Zod.object({
    id: Zod.string().nullable().optional(),
    startDate: Zod.coerce.date(translate('validate.requiredDateTime')),
    endDate: Zod.coerce.date(translate('validate.requiredDateTime')),
    location: Zod.object({
        id: Zod.string().optional(),
        title: Zod.string().optional(),
        inputValue: Zod.string().optional(),
    })
        .partial()
        .optional()
        .nullable(),
    locationId: Zod.string().nullable().optional(),
    locationString: Zod.string().nullable().optional(),
    webinarLink: Zod.string()
        .transform((value) => {
            if (!value) return undefined;

            // Add https:// protocol if missing for validation
            if (!/^https?:\/\//i.test(value)) {
                return `https://${value}`;
            }

            return value;
        })
        .pipe(
            Zod.url(translate('validate.invalidUrl'))
                .transform((value) => value.replace(/^https?:\/\//i, ''))
                .optional()
        )
        .optional()
        .nullable(),
    isServiceProviderWebinar: Zod.boolean().nullable().optional(),
    trainers: Zod.array(Zod.string()).optional().nullable(),
})
    .transform((data) => {
        // Transform location object to locationId and locationString
        // This handles the LocationSelectField output which stores location as an object
        if (data.location) {
            const location = data.location;

            // If location has an id, it's an existing location object
            // If it has inputValue, it's a newly created string location
            const locationId = location.id || null;
            const locationString = location.inputValue || location.title || '';

            return {
                ...data,
                locationId,
                locationString,
            };
        }

        return data;
    })
    .refine(
        (data) => {
            if (!data.startDate) return true;

            // Get startdate + 5 minutes
            const startAfter = new Date(data.startDate.getTime() + 300000);

            return data.endDate >= startAfter;
        },
        {
            message: translate('dateAfterStartDateMessage'),
            path: ['endDate'],
        }
    );
